import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet
} from "@react-pdf/renderer";
import PDFHeader from "../../../components/models/pdf/template/PDFHeader";
import PDFBarcode from "../../../components/models/pdf/template/PDFBarcode";
import moment from "moment";
import "../../../components/models/pdf/template/PDFFonts";
import PDFQRCode from "../../../components/models/pdf/template/PDFQrcode";

const styles = StyleSheet.create({
    page: {
        padding: 10,
        fontSize: 14
    },
    noteRow: {
        flexDirection: "row",
        marginBottom: 3
    },

    noteNumber: {
        width: 20,
        fontSize: 9
    },

    noteText: {
        flex: 1,
        fontSize: 9,
        lineHeight: 1.4
    },

    row: {
        flexDirection: "row"
    },

    col: {
        flex: 1
    },

    border: {
        border: "1 solid #000000"
    },

    sectionHeader: {
        backgroundColor: "#c6d6e5",
        padding: 4,
        fontWeight: "bold"
    },

    cell: {
        padding: 5,
        borderRight: "1 solid #000000",
        borderTop: "1 solid #000000"
    },

    signatureCell: {
        height: 50,
        padding: 5,
        borderRight: "1 solid #000000",
        borderTop: "1 solid #000000"
    },

    label: {
        fontSize: 10,
        color: "#444",
        fontFamily: "Signature"
    },

    value: {
        fontSize: 12,
        fontWeight: "bold"
    },

    title: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#ba1212"
    },

    originBox: {
        border: "1 solid #be3245",
        padding: 4,
        width: 120,
        textAlign: "center"
    }
});
const notes = [
    "Semua pajak yang timbul di negara tujuan menjadi tanggung jawab penerima atau pengirim.",
    "Pengirim wajib memberitahukan secara detil paket yang akan dikirim (uraian barang dan harga).",
    "Jika terdapat perbedaan antara invoice dan isi paket, maka segala konsekuensi yang timbul baik materil dan non materil di negara tujuan menjadi tanggung jawab pengirim.",
    "INDAK tidak bertanggung jawab jika paket ditahan oleh pihak Bea Cukai di negara tujuan.",
    "Jika terjadi kehilangan karena kelalaian INDAK, maka INDAK akan mengganti sesuai dengan nilai invoice atau maksimal 100 USD.",
    "INDAK tidak bertanggung jawab terhadap kerusakan barang yang dikarenakan sifat barang itu sendiri atau karena packing yang tidak baik.",
    "INDAK tidak bertanggung jawab jika paket harus di DESTROY (dimusnahkan) karena penerima / pengirim tidak dapat dihubungi.",
    "INDAK tidak bertanggung jawab atas kerugian yang timbul (tanggung renteng) atas keterlambatan pengiriman."
]

const notes2 = [
    <>
        {"Semua pajak yang timbul di negara tujuan menjadi tanggung jawab penerima atau pengirim."}
    </>,
    <>
        {"Pengirim wajib memberitahukan secara detil paket yang akan dikirim (uraian barang dan harga)."}
    </>,
    <>
        {"Jika terdapat perbedaan antara invoice dan isi paket, maka segala konsekuensi yang timbul baik materil dan non materil di negara tujuan menjadi tanggung jawab pengirim."}
    </>,
    <>
        <Text style={{ fontWeight: "bold", lineHeight: 1.4 }}>INDAK</Text>
        {" tidak bertanggung jawab jika paket ditahan oleh pihak "}
        <Text style={{ fontWeight: "bold" }}>BEA CUKAI</Text>
        {" di negara tujuan."}
    </>,
    <>
        {"Jika terjadi kehilangan karena kelalaian "}
        <Text style={{ fontWeight: "bold" }}>INDAK</Text>
        {", maka INDAK akan mengganti sesuai dengan nilai invoice atau maksimal "}
        <Text style={{ fontWeight: "bold" }}>100 USD</Text>
        {"."}
    </>,
    <>
        <Text style={{ fontWeight: "bold" }}>INDAK</Text>
        {" tidak bertanggung jawab terhadap kerusakan barang yang dikarenakan sifat barang itu sendiri atau karena packing yang tidak baik."}
    </>,
    <>
        <Text style={{ fontWeight: "bold" }}>INDAK</Text>
        {" tidak bertanggung jawab jika paket harus di DESTROY (dimusnahkan) karena penerima / pengirim tidak dapat dihubungi."}
    </>,
    <>
        <Text style={{ fontWeight: "bold" }}>INDAK</Text>
        {" tidak bertanggung jawab atas kerugian yang timbul (tanggung renteng) atas keterlambatan pengiriman."}
    </>
]

const ResiPDF = ({ record }) => (
  <Document>
    <Page size={{ width: 900, height: 800 }} style={styles.page}>
        <PDFHeader />

      {/* HEADER */}
      <View style={[styles.row, { justifyContent: "space-between", marginBottom: 6 }]}>
        <Text style={[styles.title, { fontWeight: 5}]}>DELIVERING HAPPINESS</Text>

        <View style={{ flexDirection: "row", gap: 5 }}>
          <View style={styles.originBox}>
            <Text style={styles.label}>ORIGIN</Text>
            <Text style={styles.value}>INDONESIA</Text>
          </View>

          <View style={styles.originBox}>
            <Text style={styles.label}>DESTINATION</Text>
            <Text style={styles.value}>{(record?.tujuanNegara || record?.TujuanNegara || "")?.toUpperCase()}</Text>
          </View>
        </View>
      </View>

      {/* MAIN GRID */}
      <View style={[styles.row, styles.border]}>

        {/* LEFT COLUMN */}
        <View style={{ flex: 1 }}>

          {/* A FROM */}
          <Text style={styles.sectionHeader}>A. FROM (SHIPPER)</Text>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Shipper Account</Text>
              <Text>{record.namaPengirim}</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Shipper Ref</Text>
              <Text>{record.shipperRef}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>From</Text>
              <Text>INDAK</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Phone</Text>
              <Text>6282113580471</Text>
            </View>
          </View>

          <View style={[styles.cell]}>
            <Text style={styles.label}>Street Address</Text>
            <Text>Jalan Bango</Text>
          </View>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>City</Text>
              <Text>Jakarta Selatan</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>State / Province</Text>
              <Text>DKI Jakarta</Text>
            </View>
          </View>

          {/* B RECEIVER */}
          <Text style={styles.sectionHeader}>B. TO (RECEIVER)</Text>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Receiver Account</Text>
              <Text>{record.receiverAccount}</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Receiver Ref</Text>
              <Text>{record.namaPenerima}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Receiver</Text>
              <Text>{record.namaPenerima}</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Phone</Text>
              <Text>{record.noTeleponPenerima}</Text>
            </View>
          </View>

          <View style={styles.cell}>
            <Text style={styles.label}>Address</Text>
            <Text>{record.alamatPenerima}</Text>
          </View>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>City</Text>
              <Text>{(record?.tujuanKota || record?.TujuanKota || "")?.toUpperCase()}</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>State / Province</Text>
              <Text>{(record?.tujuanProvinsi || record?.TujuanProvinsi || "")?.toUpperCase()}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Country</Text>
              <Text>{(record?.tujuanNegara || record?.TujuanNegara || "")?.toUpperCase()}</Text>
            </View>

            <View style={[styles.cell, { flex: 1 }]}>
              <Text style={styles.label}>Postal Code</Text>
              <Text>{record.kodePos}</Text>
            </View>
          </View>

          {/* C SIGNATURE */}
          <Text style={styles.sectionHeader}>
            C. SHIPPER'S SIGNATURE & AUTHORIZATION
          </Text>

          <View style={styles.row}>
            <View style={[styles.signatureCell, { flex: 1 }]}>
              <Text style={styles.label}>Shipper Signature</Text>
            </View>

            <View style={[styles.signatureCell, { flex: 1 }]}>
              <Text style={styles.label}>Date / Time</Text>
              <Text style={{ fontSize: 10, marginTop: 10, fontWeight: "bold" }}>
                {record?.createdAt ? moment(record.createdAt).format("DD-MM-YYYY HH:mm") : ""}
              </Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={[styles.signatureCell, { flex: 1 }]}>
              <Text style={styles.label}>Receiver Signature</Text>
            </View>

            <View style={[styles.signatureCell, { flex: 1 }]}>
              <Text style={styles.label}>Date / Time</Text>
              <Text style={{ fontSize: 10, marginTop: 10, fontWeight: "bold" }}>
                {(() => {
                  const statusLower = record?.status?.toLowerCase();
                  const isDelivered = record?.kodePengiriman === "01" && statusLower === "delivered";
                  const isPaidOut = (record?.kodePengiriman === "02" || record?.kodePengiriman === "03") && statusLower === "paid out";
                  if ((isDelivered || isPaidOut) && record?.trackingAt) {
                    return moment(record.trackingAt).format("DD-MM-YYYY HH:mm");
                  }
                  return "";
                })()}
              </Text>
            </View>
          </View>

        </View>

        {/* RIGHT COLUMN */}
        <View style={{ flex: 1 }}>
            <Text style={styles.sectionHeader}>
                D. SHIPMENT INFORMATION
            </Text>

            <View style={styles.row}>
                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>No. Pieces</Text>
                <Text>1</Text>
                </View>

                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>Actual Weight</Text>
                <Text>{record.jumlahBarang}</Text>
                </View>

                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>Chargeable Weight</Text>
                <Text>{Math.ceil(record.jumlahBarang)}</Text>
                </View>

                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>Country of Manufacture</Text>
                <Text></Text>
                </View>
            </View>
            <View style={styles.row}>
                <View style={[styles.cell, { flex: 3 }]}>
                    <Text style={styles.label}>Description of Goods / Harmonized Code</Text>
                    <Text>{record.namaBarang}</Text>
                </View>
            
                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>Custom Value</Text>
                <Text>{record.value}</Text>
                </View>

                <View style={[styles.cell, { flex: 1 }]}>
                <Text style={styles.label}>Currency</Text>
                <Text>{record.currency}</Text>
                </View>
            </View>

            {/* BARCODE AREA */}
            <View style={[styles.cell, { height: 100 }]}>
                <Text style={styles.label}>Connote Barcode</Text>
                <View style={{ alignItems: "center", marginTop: 5 }}>
                    <PDFBarcode value={record.noResi} />
                    <Text>{record.noResi}</Text>
                </View>
            </View>

            <View style={[styles.cell, { height: 110, flexDirection: "row" }]}>
                <View style={{ flex: 1 }}>
                    <Text style={styles.label}>Airwaybill Number</Text>

                    <Text style={{ fontSize: 16, fontWeight: "bold", marginTop: 6 }}>
                    # {record.noResi}
                    </Text>

                    <Text style={{ marginTop: 10 }}>
                    REFF # PU
                    </Text>
                </View>
                <View style={{ width: 130, alignItems: "center", justifyContent: "center" }}>
                    <PDFQRCode value={record.noResi} />
                </View>
            </View>
            <View style={{ textAlign: "right", marginRight: 10 }}>
                <Text>
                    <Text style={styles.label}>Release Date : &ensp;</Text>
                    <Text style={{ fontSize: 12, marginTop: 6, fontWeight: "bold" }}>
                        {moment(record.createdAt).format("DD-MM-YYYY")}
                    </Text>
                </Text>
            </View>

            {/* <View style={[styles.cell, { height: 120 }]}>
                <Text style={[styles.label, {fontWeight: "bold"}]}>NOTES</Text>
                <Text style={{ fontSize: 10 }}>
                    1. Semua pajak yang timbul di negara tujuan menjadi tanggung jawab penerima atau pengirim.
                    {"\n"}
                    2. Pengirim wajib memberitahukan secara detil paket yang akan dikirim (uraian barang dan harga).
                    {"\n"}
                    3. Jika terdapat perbedaan antara invoice dan isi paket, maka segala konsekuensi yang timbul baik materil dan non materil di negara tujuan menjadi tanggung jawab pengirim.
                    {"\n"}
                    4. <b>INDAK</b> tidak bertanggung jawab jika paket ditahan oleh pihak <b>Bea Cukai</b> di negara tujuan.
                    {"\n"}
                    5. Jika terjadi kehilangan karena kelalaian <b>INDAK</b>, maka INDAK akan mengganti sesuai dengan nilai invoice atau maksimal 100 USD.
                    {"\n"}
                    6. INDAK tidak bertanggung jawab terhadap kerusakan barang yang dikarenakan sifat barang itu sendiri atau karena packing yang tidak baik.
                    {"\n"}
                    7. INDAK tidak bertanggung jawab jika paket harus di DESTROY (dimusnahkan) karena penerima / pengirim tidak dapat dihubungi.
                    {"\n"}
                    8. INDAK tidak bertanggung jawab atas kerugian yang timbul (tanggung renteng) atas keterlambatan pengiriman.
                </Text>
            </View> */}
        </View>
      </View>
    </Page>
  </Document>
);

export default ResiPDF;